const mutationtypes = Object.freeze({
  UPDATE_TRANSFERLISTSELECT_STATE: 'updateTransferListSelectState',
  UPDATE_TRANSFERLISTTABLESEARCH_STATE: 'updateTransferListTableSearchState',
  UPDATE_TRANSFERNAVIGATIONBACKBUTTON_STATE: 'updateTransferNavigationBackButtonState',
  UPDATE_TRANSFERLIST_SELECTED_YEAR: 'updateTransferListSelectedYear',
  UPDATE_TRANSFERLIST_SELECTED_MONTH: 'updateTransferListSelectedMonth',
  UPDATE_TRANSFERLIST_SELECTED_DEPARTMENT: 'updateTransferListSelectedDepartment',
  UPDATE_TRANSFERLIST_SELECTED_FACILITY: 'updateTransferListSelectedFacility',
  UPDATE_TRANSFERLIST_SELECTED_STATE: 'updateTransferListSelectedState',
  UPDATE_TRANSFERLIST_SELECTED_BUHA_SEARCH_STATE: 'updateTransferListSelectedBuhaSearchState',
  UPDATE_TRANSFERLISTFIRSTLOAD_STATE: 'updateTransferListFirstLoadState',
  UPDATE_WOCTRANSFERLISTSELECT_STATE: 'updateWocTransferListSelectState',
  UPDATE_WOCTRANSFERLISTTABLESEARCH_STATE: 'updateWocTransferListTableSearchState',
  UPDATE_WOCTRANSFERLISTFIRSTLOAD_STATE: 'updateWocTransferListFirstLoadState'
})

export default mutationtypes
